import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// --- Family Swiper reusable initializer ---
let familySwiper;
function initFamilySwiper() {
  const container = document.querySelector(".swiperFamily");
  if (!container) return;

  // Destroy previous instance (when swapping content)
  if (familySwiper) {
    try {
      familySwiper.destroy(true, true);
    } catch (e) {}
    familySwiper = null;
  }

  // Scope navigation buttons to the current employees grid
  const wrapper = container.closest("[data-employees]") || document;
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  if (nextEl) nextEl.style.pointerEvents = "auto";
  if (prevEl) prevEl.style.pointerEvents = "auto";

  familySwiper = new Swiper(".swiperFamily", {
    modules: [Navigation],
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    breakpoints: {
      0: { slidesPerView: 1.5, spaceBetween: 20 },
      480: { slidesPerView: 2.5, spaceBetween: 20 },
      767: { slidesPerView: 3.5, spaceBetween: 30 },
    },
  });
}

const hero = new Swiper(".slider-hero", {
  // configure Swiper to use modules
  modules: [Pagination, Autoplay],
  pagination: {
    el: ".hero-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});
var nieuws = new Swiper(".nieuws-slider", {
  modules: [Navigation, Autoplay],
  slidesPerView: 4,
  spaceBetween: 18,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.5,
    },
    425: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3.5,
    },
    1024: {
      slidesPerView: 4,
    },
    1650: {
      slidesPerView: 5.5,
    },
    2400: {
      slidesPerView: 6.5,
    },
  },
});

var merken = new Swiper(".merken-swiper", {
  modules: [Autoplay],
  spaceBetween: 40,
  speed: 9000,
  slidesPerView: "auto",
  loop: true,
  centeredSlides: true,
  allowTouchMove: false,
  autoplay: {
    delay: 0.5,
    disableOnInteraction: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 6,
      spaceBetween: 40,
    },
  },
});

var swiperRealisatie = new Swiper(".swiperRealisatie", {
  modules: [Navigation, Autoplay],
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

initFamilySwiper();

// Re-init after Sprig (HTMX) swaps when the employees grid is replaced
// (Sprig uses htmx under the hood and fires this event after swapping content)
document.addEventListener("htmx:afterSwap", function (e) {
  if (
    e &&
    e.detail &&
    e.detail.target &&
    e.detail.target.matches("[data-employees]")
  ) {
    initFamilySwiper();
  }
});

// Also ensure it runs once the DOM is ready in case this script loads before markup
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFamilySwiper);
} else {
  initFamilySwiper();
}
